import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { trans } from '@spotahome/soyuz/client';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import CurrencyFormatter from '@spotahome/marketplace-common/src/utils/CurrencyFormatter';
import SoyuzAnalytics from '@spotahome/soyuz-analytics';
import { getDateAsUTC } from '@spotahome/ui-library/src/tenant/components/utils/dateUtils';

import './OtherProperties.scss';

const getCurrency = homecard =>
  new CurrencyFormatter(
    homecard.currencyLabel,
    homecard.currencySymbol,
    homecard.currencyIsoCode
  );

const handleHomecardClick = () => {
  SoyuzAnalytics.sendGA4Event('view_landlord_alternative', {
    section: 'other-landlord-properties',
    method: 'visit'
  });
};

const onImageChange = () => {
  SoyuzAnalytics.sendGA4Event('view_landlord_alternative_image', {
    method: 'next-chevron',
    section: 'other-landlord-properties'
  });
};

const OtherProperties = ({ homecards }) => {
  const currentYear = getDateAsUTC(new Date()).getFullYear();
  useEffect(() => {
    SoyuzAnalytics.sendGA4Event('show', {
      number_of_items: homecards?.length,
      section: 'other-landlord-properties'
    });
  }, [homecards]);

  return (
    !!homecards.length && (
      <div className="other-properties">
        <div className="other-properties__title">
          {trans('listing.other_landlord_properties.title')}
        </div>
        <div className="other-properties__wrapper">
          {homecards.map((homecard, position) => {
            const firstAvailableDate = getDateAsUTC(
              new Date(homecard.firstAvailableDate)
            );
            const firstAvailableYear = firstAvailableDate?.getFullYear();
            return (
              <div
                key={homecard.id}
                className="other-properties__item"
                data-testid={`homecard-${homecard.id}`}
              >
                <Homecard
                  isShowStatus
                  data={homecard}
                  position={position}
                  currency={getCurrency(homecard)}
                  tracking="ga-detail-properties-around-card"
                  onClick={handleHomecardClick}
                  hasLazyLoad
                  showAvailableFromYear={firstAvailableYear !== currentYear}
                  withTransparentBackground
                  pageType="product_page"
                  section="similar_properties"
                  onImageChange={onImageChange}
                />
              </div>
            );
          })}
        </div>
      </div>
    )
  );
};

OtherProperties.propTypes = {
  homecards: PropTypes.arrayOf(PropTypes.object).isRequired
};
export default OtherProperties;
